import { AddUserModal } from "./AddUserModal";

export default AddUserModal;
